export const CSV_SAFE_REGEX = /^[^";,]*$/;
